/* Help contextual por módulo. Consumido por `ModuleHelp`. */

export const MODULE_HELP = {
  dashboard: {
    title: "Painel",
    summary:
      "Visão consolidada das fontes, insumos e Sementes de Futuro cadastradas no Projeto Nostradamus.",
    details:
      "Apresenta indicadores por área temática, status, origem dos dados, distribuição geográfica e produtividade. Use os filtros e drilldowns para investigar números específicos.",
    tips: [
      "Clique nos cards para abrir o detalhamento por perfil/origem.",
      "O painel agrega TODOS os dados ativos da base.",
    ],
  },
  cadastro: {
    title: "Cadastro de Semente",
    summary:
      "Cadastrar manualmente uma Fonte, identificar Insumos prospectivos e criar Sementes de Futuro.",
    details:
      "O cadastro pode ser preenchido manualmente ou auxiliado por IA, sempre seguindo para Revisão Humana antes de aparecer em mapas e indicadores.",
    tips: [
      "Use Upload com IA para extrair Insumos de PDFs.",
      "Sempre preencha a Citação Direta — é a evidência primária da Semente.",
      "Horizonte mínimo: 2030+.",
    ],
  },
  revisao: {
    title: "Revisão Humana",
    summary:
      "Curadoria metodológica dos registros antes da aprovação final.",
    details:
      "O revisor verifica se a Fonte, o Insumo, a Classificação, o PESTEL, o Recorte Geográfico e o Horizonte Temporal estão coerentes.",
    tips: [
      "Verifique se o Insumo é realmente prospectivo (não descritivo).",
      "A Citação Direta deve estar literal — sem reformulação.",
      "Use o Diff Humano × IA para entender o que foi sugerido pela IA.",
    ],
  },
  revisaoLegada: {
    title: "Revisão Legada (Diff IA)",
    summary:
      "Curadoria dos registros importados da Base Legada com sugestões da IA.",
    details:
      "Compara o que veio da planilha original com o que a IA enriqueceu, destacando campos alterados. O revisor decide o que vai para a base final.",
  },
  biblioteca: {
    title: "Biblioteca",
    summary:
      "Acervo central das fontes, insumos e sementes registradas.",
    details:
      "Permite consultar, filtrar, abrir detalhes, verificar origem, status, pesquisador responsável, revisão e aprovação. Use a busca para localizar registros específicos.",
  },
  mapa: {
    title: "Mapa Geográfico",
    summary:
      "Visualização geográfica das publicações, impactos e Sementes de Futuro.",
    details:
      "Permite observar países, regiões, vetores temáticos e concentração de registros. Clique em um marcador para ver os registros associados.",
  },
  legado: {
    title: "Importar Base Legada",
    summary:
      "Importar e gerenciar a planilha histórica F_SP&D — Base de Literaturas.",
    details:
      "Os registros importados entram como fontes reais pendentes de enriquecimento e revisão. Eles NÃO são automaticamente aprovados como Sementes de Futuro.",
    tips: [
      "A deduplicação detecta duplicatas exatas e fuzzy (Jaccard) entre lotes.",
      "Use 'Simulação' antes de Confirmar — preview do que será importado.",
    ],
  },
  coleta: {
    title: "Coleta Automática",
    summary:
      "Busca periódica de fontes abertas, relatórios e publicações relacionadas aos vetores do LSC.",
    details:
      "Pode operar com coleta real (Crossref, OpenAlex, Semantic Scholar), agregação interna ou dados demonstrativos.",
    tips: [
      "Os jobs podem ser agendados para execução periódica.",
      "Resultados entram como sementes pendentes para revisão.",
    ],
  },
  coletaPublica: {
    title: "Coleta Pública",
    summary:
      "Configuração do Radar de Notícias dos Vetores LSC exibido na home pública.",
    details:
      "Permite atualizar manualmente o feed público (RSS, GDELT, NewsAPI, Mediastack) e ver histórico de coletas.",
  },
  usuarios: {
    title: "Usuários",
    summary:
      "Gestão de usuários: criação, validação, ativação, suspensão.",
    details:
      "Pesquisadores importados pela planilha podem aparecer como pendentes de validação. Apenas usuários 'ativos' têm acesso à área restrita.",
  },
  produtividade: {
    title: "Contribuições por Usuário",
    summary:
      "Dashboard que mostra a quantidade de registros pesquisados, importados, enriquecidos, revisados ou aprovados por cada usuário.",
    details:
      "Permite avaliar engajamento e identificar gargalos de revisão.",
  },
  auditoria: {
    title: "Auditoria",
    summary:
      "Registro de ações relevantes no sistema: login, importação, revisão, aprovação, enriquecimento por IA, alteração de usuários e limpezas.",
    details:
      "Trilha imutável usada para conformidade, rastreabilidade e governança institucional.",
  },
  radarNoticias: {
    title: "Radar de Notícias",
    summary:
      "Feed público de notícias abertas classificadas pelos vetores do LSC.",
    details:
      "O Radar não exibe dados internos nem representa validação metodológica. Indica claramente se os dados são reais, agregados, RSS ou demonstrativos.",
  },
  legendas: {
    title: "Legendas do Sistema",
    summary: "Glossário central de siglas, classificações metodológicas e termos do Projeto Nostradamus.",
    details: "Use a busca para localizar um termo ou navegue por categoria (Vetores LSC, Classificação, PESTEL, Metodologia, Sistema).",
  },
};
